import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../assets/images/logo-gray.png";
import { menuData } from "../data/header";

function HeaderNavigation() {
  const location = useLocation(); // Get current route

  return (
    <Navbar expand="lg" className="navbar-new fixed">
      <Navbar.Brand href="/">
        <img src={logo} alt="logo" className="navbar-new-logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {menuData.map((menu, index) => {
            // Check if any dropdown item is active
            const isDropdownActive = menu.items.some(
              (item) => location?.pathname === item.link
            );

            return (
              <NavDropdown
                key={index}
                className="custom-dropdown"
                title={
                  <span
                    className={`dropdown-title ${isDropdownActive ? "active-dropdown" : ""
                      }`}
                  >
                    {menu.title}
                  </span>
                }
                id={`nav-dropdown-${index}`}
              >
                {menu.items.map((item, subIndex) => (
                  <NavDropdown.Item
                    key={subIndex}
                    as={NavLink}
                    to={item.link}
                    className={({ isActive }) =>
                      `dropdown-item-custom ${isActive ? "active-item" : ""}`
                    }
                  >
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            );
          })}
        </Nav>

        {/* Buttons Section */}
        <div className="navbar-buttons">
          {/* <NavLink
            to={{
              pathname: "/create-account",
              state: { acc: "Real" },
            }}
            className="custom-btn"
          >
            New Account
          </NavLink> */}
<div className="open-account-row">
  <div className="open-account-title">
    Open Account
  </div>

  <a
    href="https://www.asaanconnect.com/cdc/cgp/r/centralized-gateway-portal/home"
    target="_blank"
    rel="noopener noreferrer"
    className="custom-btn"
  >
    Via CDC
  </a>

  <a
    href="https://www.aof.com.pk/?MTg2MjgyNTQzNzY0OTc5MjI4MzQyODYyNTI1NDY4NjQ4NDYyNzcyNw=="
    target="_blank"
    rel="noopener noreferrer"
    className="custom-outline-btn"
  >
    Via Orbit
  </a>
</div>

        </div>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default HeaderNavigation;
